<template>
  <div class="VersionControlTable">
      <headers></headers>
      <h1>经理云生态管理平台</h1>
      <h3>版本对照表</h3>
      <div class="VersionControlTable-info1">
          <div>
              <ul>
                  <li>版本对照</li>
                  <li>营业模块</li>
                  <li>验光模块</li>
                  <li>会员管理</li>
                  <li>库存管理</li>
                  <li>商品调拨</li>
                  <li>商品加工</li>
                  <li>商品退换货</li>
                  <li>商品定制</li>
                  <li>考勤管理</li>
                  <li>报销管理</li>
                  <li>店铺详情</li>
                  <li>交接班</li>
                  <li>系统设置</li>
                  <li>手动入库</li>
                  <li>商品出库</li>
                  <li>打印标签</li>
                  <li>采购补货</li>
                  <li>加工中心</li>
                  <li>打印设置</li>
                  <li>商品检测</li>
                  <li>加工师加工</li>
                  <li>成品检测</li>
                  <li>订单中心</li>
                  <li>手机验光</li>
                  <li>远程下单</li>
                  <li>微信消息推送</li>
                  <li>扫码入库</li>
                  <li>扫码盘点</li>
                  <li>活动推广</li>
                  <li>优惠券/折扣券</li>
                  <li>隐形过期提醒</li>
                  <li>店铺管理</li>
                  <li>员工业绩</li>
                  <li>人员权限</li>
                  <li>商品模板导入</li>
                  <li>商品价格策略</li>
                  <li>供应商管理</li>
                  <li>连锁店/直销店</li>
                  <li>加工配置</li>
                  <li>支付配置</li>
                  <li>报表统计</li>
                  <li>GSP管理</li>
              </ul>
          </div>
          <div>
              <ul>
                  <li>
                      <span>简易版</span>
                      <span>零售版</span>
                      <span>仓库版</span>
                      <span>批发商版</span>
                      <span>加工中心版</span>
                  </li>
                  <li>
                      <span>√</span>
                      <span>√</span>
                      <span></span>
                      <span></span>
                      <span></span>
                  </li>
                  <li>
                      <span>√</span>
                      <span>√</span>
                      <span></span>
                      <span></span>
                      <span></span>
                  </li>
                  <li>
                      <span>√</span>
                      <span>√</span>
                      <span></span>
                      <span></span>
                      <span></span>
                  </li>
                  <li>
                      <span>√</span>
                      <span>√</span>
                      <span>√</span>
                      <span>√</span>
                      <span>√</span>
                  </li>
                  <li>
                      <span></span>
                      <span>√</span>
                      <span></span>
                      <span></span>
                      <span></span>
                  </li>
                  <li>
                      <span></span>
                      <span>√</span>
                      <span></span>
                      <span></span>
                      <span>√</span>
                  </li>
                  <li>
                      <span></span>
                      <span>√</span>
                      <span>√</span>
                      <span>√</span>
                      <span>√</span>
                  </li>
                  <li>
                      <span></span>
                      <span>√</span>
                      <span>√</span>
                      <span>√</span>
                      <span>√</span>
                  </li>
                  <li>
                      <span>√</span>
                      <span>√</span>
                      <span>√</span>
                      <span>√</span>
                      <span>√</span>
                  </li>
                  <li>
                      <span>√</span>
                      <span>√</span>
                      <span>√</span>
                      <span>√</span>
                      <span>√</span>
                  </li>
                  <li>
                      <span>√</span>
                      <span>√</span>
                      <span>√</span>
                      <span>√</span>
                      <span>√</span>
                  </li>
                  <li>
                      <span>√</span>
                      <span>√</span>
                      <span>√</span>
                      <span>√</span>
                      <span>√</span>
                  </li>
                  <li>
                      <span>√</span>
                      <span>√</span>
                      <span>√</span>
                      <span>√</span>
                      <span>√</span>
                  </li>
                  <li>
                      <span></span>
                      <span></span>
                      <span>√</span>
                      <span>√</span>
                      <span></span>
                  </li>
                  <li>
                      <span></span>
                      <span></span>
                      <span>√</span>
                      <span>√</span>
                      <span></span>
                  </li>
                  <li>
                      <span></span>
                      <span></span>
                      <span>√</span>
                      <span>√</span>
                      <span></span>
                  </li>
                  <li>
                      <span></span>
                      <span></span>
                      <span>√</span>
                      <span>√</span>
                      <span></span>
                  </li>
                  <li>
                      <span></span>
                      <span></span>
                      <span></span>
                      <span></span>
                      <span>√</span>
                  </li>
                  <li>
                      <span></span>
                      <span></span>
                      <span>√</span>
                      <span>√</span>
                      <span>√</span>
                  </li>
                  <li>
                      <span></span>
                      <span></span>
                      <span></span>
                      <span></span>
                      <span>√</span>
                  </li>
                  <li>
                      <span></span>
                      <span></span>
                      <span></span>
                      <span></span>
                      <span>√</span>
                  </li>
                  <li>
                      <span></span>
                      <span></span>
                      <span></span>
                      <span></span>
                      <span>√</span>
                  </li>
                  <li>
                      <span></span>
                      <span></span>
                      <span></span>
                      <span>√</span>
                      <span></span>
                  </li>
                  <li>
                      <span>√</span>
                      <span>√</span>
                      <span></span>
                      <span></span>
                      <span></span>
                  </li>
                  <li>
                      <span>√</span>
                      <span>√</span>
                      <span></span>
                      <span>√</span>
                      <span>√</span>
                  </li>
                  <li>
                      <span>√</span>
                      <span>√</span>
                      <span>√</span>
                      <span>√</span>
                      <span>√</span>
                  </li>
                  <li>
                      <span>√</span>
                      <span>√</span>
                      <span>√</span>
                      <span>√</span>
                      <span>√</span>
                  </li>
                  <li>
                      <span>√</span>
                      <span>√</span>
                      <span>√</span>
                      <span>√</span>
                      <span>√</span>
                  </li>
                  <li>
                      <span>√</span>
                      <span>√</span>
                      <span>√</span>
                      <span>√</span>
                      <span>√</span>
                  </li>
                  <li>
                      <span></span>
                      <span>√</span>
                      <span></span>
                      <span></span>
                      <span></span>
                  </li>
                  <li>
                      <span></span>
                      <span>√</span>
                      <span>√</span>
                      <span>√</span>
                      <span></span>
                  </li>
                  <li>
                      <span>√</span>
                      <span>√</span>
                      <span>√</span>
                      <span>√</span>
                      <span>√</span>
                  </li>
                  <li>
                      <span>√</span>
                      <span>√</span>
                      <span>√</span>
                      <span>√</span>
                      <span>√</span>
                  </li>
                  <li>
                      <span>√</span>
                      <span>√</span>
                      <span>√</span>
                      <span>√</span>
                      <span>√</span>
                  </li>
                  <li>
                      <span>√</span>
                      <span>√</span>
                      <span>√</span>
                      <span>√</span>
                      <span>√</span>
                  </li>
                  <li>
                      <span>√</span>
                      <span>√</span>
                      <span>√</span>
                      <span>√</span>
                      <span>√</span>
                  </li>
                  <li>
                      <span></span>
                      <span>√</span>
                      <span>√</span>
                      <span>√</span>
                      <span>√</span>
                  </li>
                  <li>
                      <span></span>
                      <span>√</span>
                      <span>√</span>
                      <span></span>
                      <span></span>
                  </li>
                  <li>
                      <span></span>
                      <span>√</span>
                      <span>√</span>
                      <span></span>
                      <span>√</span>
                  </li>
                  <li>
                      <span>√</span>
                      <span>√</span>
                      <span>√</span>
                      <span>√</span>
                      <span>√</span>
                  </li>
                  <li>
                      <span>√</span>
                      <span>√</span>
                      <span>√</span>
                      <span>√</span>
                      <span>√</span>
                  </li>
                  <li>
                      <span>√</span>
                      <span>√</span>
                      <span>√</span>
                      <span>√</span>
                      <span>√</span>
                  </li>
              </ul>
          </div>
      </div>
      <footers></footers>
  </div>
</template>

<script>
import footer from "../components/footer";
import header from "../components/headers";

export default {
  name:'',
  components: { 
      footers: footer,
headers: header
   },
  data() {
    return {
    };
  },

  methods: {
  },
  watch: {
  }
};
</script>

<style scoped lang="less">
* {
  padding: 0;
  margin: 0;
  list-style: none;
  box-sizing: border-box;
} 
.VersionControlTable{
    width:100%;
    height:100%;
    h1{
        color:#258FFC;
        text-align: center;
        margin-top: 60px;
    }
    h3{
        text-align: center;
        line-height: 60px;
        color: #323232;
        font-weight: 600;
    }
    .VersionControlTable-info1{
        display: flex;
        width:60%;
        margin: 0 auto;
        margin-bottom: 100px;
        @media screen and (max-width: 850px) {
            width: 100%;
        }
        div:nth-child(1){
            width:20%;
            ul{
                width:100%;
                li{
                    width:100%;
                    height:40px;
                    line-height: 40px;
                    text-align: center;
                    color:rgba(255,255,255,1);
                    background: #258FFC;
                    border-bottom:1px solid #fff;
                }
            }
        }
        div:nth-child(2){
            width:80%;
            display: flex;
            ul{
                width:100%;
                margin: 0 auto;
                border: 1px solid #f5f5f5;
                border-bottom: none;
                li{
                    width:100%;
                    height:40px;
                    border-bottom: 1px solid #f5f5f5;
                    display: flex;
                    span{
                        display: inline-block;
                        width:20%;
                        height:40px;
                        line-height: 40px;
                        text-align: center;
                        border-right:1px solid #f5f5f5;
                    }
                    &:hover{
                        background: rgb(223, 239, 255);
                        cursor: pointer;
                    }
                }
            }
        }
    }
}
</style>
